module.exports = __webpack_public_path__ + "static/media/special_pointer_right.f293d2a0.svg";